export default __webpack_public_path__ + "static/young-toddler13-18ad9d3a53dc70515f97eae0bd4e42eb.jpg";